class PeopleCheckingOut extends HTMLElement {
  constructor() {
    super();

    this.minPeople = parseInt(this.dataset.min) || 3;
    this.maxPeople = parseInt(this.dataset.max) || 12;
    this.countElement = this.querySelector('.people-count');
    this.currentCount = this.minPeople;

    if (this.countElement) {
      this.startAnimation();
    }
  }

  startAnimation() {
    // Initial delay before first change (3-8 seconds)
    const initialDelay = this.getRandomDelay(3000, 8000);

    setTimeout(() => {
      this.updateCount();
      this.scheduleNextUpdate();
    }, initialDelay);
  }

  scheduleNextUpdate() {
    // Random delay between updates (4-12 seconds)
    const delay = this.getRandomDelay(4000, 12000);

    setTimeout(() => {
      this.updateCount();
      this.scheduleNextUpdate();
    }, delay);
  }

  updateCount() {
    // Get a new count that's different from current
    let newCount;
    do {
      newCount = this.getRealisticCount();
    } while (newCount === this.currentCount);

    this.currentCount = newCount;
    this.animateToCount(newCount);
  }

  getRealisticCount() {
    // Create a weighted distribution favoring lower numbers (more realistic)
    const range = this.maxPeople - this.minPeople;
    const random = Math.random();

    // Exponential distribution to favor lower numbers
    // Numbers closer to min are more likely
    const skewedRandom = Math.pow(random, 1.5);
    const count = Math.floor(skewedRandom * range) + this.minPeople;

    return Math.min(this.maxPeople, Math.max(this.minPeople, count));
  }

  animateToCount(targetCount) {
    const currentValue = parseInt(this.countElement.textContent) || this.minPeople;
    const difference = targetCount - currentValue;
    const steps = Math.abs(difference);
    const stepDuration = 50; // 50ms per step

    if (steps === 0) return;

    let currentStep = 0;
    const direction = difference > 0 ? 1 : -1;

    const interval = setInterval(() => {
      currentStep++;
      const newValue = currentValue + (direction * currentStep);
      this.countElement.textContent = newValue;

      if (currentStep >= steps) {
        clearInterval(interval);
      }
    }, stepDuration);
  }

  getRandomDelay(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

customElements.define('people-checking-out', PeopleCheckingOut);
